import {
  documentToReactComponents,
  Options
} from '@contentful/rich-text-react-renderer'
import { BLOCKS, Document } from '@contentful/rich-text-types'
import { ButtonLink } from '@components/ui/Button'
import Link from '@components/ui/Link'

import styles from './styles.module.scss'
import { Asset } from 'types/contentful/graphQlApi'

function Paragraph({ text }: { text: string }) {
  return text === '' ? null : <p>{text}</p>
}

const options: Options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: node => {
      return node.content.map((childNode, index) => {
        if (childNode.nodeType === 'text') {
          const { value } = childNode || {}
          return <Paragraph text={value} key={`${value}-${index}`} />
        }
        if (childNode.nodeType === 'hyperlink') {
          if (childNode.data.uri.includes('@')) {
            const { value }: any = childNode.content[0] || {}
            return (
              <Link
                key={`${value}-${index}`}
                href={`mailto:${childNode.data.uri}`}
                className={styles.IconCard__contentLink}
              >
                {value}
              </Link>
            )
          }
          if (/[0-9]/.test(childNode.data.uri)) {
            const { value }: any = childNode.content[0] || {}
            return (
              <Link
                key={`${value}-${index}`}
                href={`tel:${childNode.data.uri}`}
                className={styles.IconCard__contentLink}
              >
                {value}
              </Link>
            )
          }
          return (
            <Link
              key={`${childNode.data.ur}`}
              href={childNode.data.uri}
              className={styles.IconCard__contentLink}
            >
              {childNode.data.uri}
            </Link>
          )
        }
        if (childNode.nodeType === 'embedded-entry-inline') {
          const { text, uri } = childNode.data.target.fields || {}
          return (
            <Link
              key={`${uri}`}
              href={uri}
              className={styles.IconCard__contentLink}
            >
              {text}
            </Link>
          )
        }
        return null // Ensure a fallback for other node types
      })
    }
  }
}

export type IconCardProps = {
  title: string
  description: {
    content: Document[]
  }
  icon: Asset
}

export default function IconCard({ title, description, icon }: IconCardProps) {
  return (
    <article className={styles.IconCard}>
      <div className={styles.IconCard__image}>
        <img src={icon.file.url} alt={title} />
      </div>
      <h3 className={styles.IconCard__title}>{title}</h3>
      {description.content.map(node =>
        documentToReactComponents(node, options)
      )}
    </article>
  )
}
